<template>
  <div
    class="position-relative"
    :class="readOnly ? 'picture-container-readonly' : 'picture-container'"
  >
    <b-modal hide-footer hide-header v-model="cameraModal">
      <video
        v-show="!isPhotoTaken"
        ref="camera"
        :width="455"
        :height="335.5"
        autoplay
      ></video>
      <canvas
        v-show="isPhotoTaken"
        id="photoTaken"
        ref="canvas"
        :width="455"
        :height="335.5"
      ></canvas>
      <div class="text-center">
        <b-button variant="danger" class="mt-3 mr-3" @click="takePhoto"
          >Take Picture</b-button
        >
        <b-button variant="primary" class="mt-3" @click="closeCameraModal"
          >Close</b-button
        >
      </div>
    </b-modal>
    <div class="token-container" :style="!image ? 'padding-top:20px' : ''">
      <img v-if="image" :src="image" />
      <div v-else>
        <i
          class="fa fa-picture-o d-block"
          style="font-size:15px"
          aria-hidden="true"
        ></i>
        <p class="d-block" style="font-size: 12px">{{ labelText }}</p>
      </div>
    </div>
    <div class="hover-icons">
      <input
        ref="fileUpload"
        type="file"
        @change="setImage"
        accept="image/*"
        hidden
      />
      <div
        class="w-100 h-100 justify-content-center align-items-center icons-container"
      >
        <i
          v-if="readOnly"
          class="mr-3 text-primary fa fa-search"
          v-on="{ click: showImage }"
          aria-hidden="true"
        ></i>
        <i
          v-if="!readOnly"
          :class="image ? 'fa fa-search' : 'fa fa-upload'"
          class="mr-3 text-primary"
          v-on="{ click: image ? showImage : chooseFile }"
          aria-hidden="true"
        ></i>
        <i
          v-if="!readOnly"
          :class="image ? 'fa fa-trash text-danger' : 'fa fa-camera'"
          class="text-primary"
          v-on="{ click: image ? resetImage : toggleCamera }"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import { fileToBase64, resizeImage } from "../../helpers/file";
export default {
  name: "ImagePicker",
  props: {
    value: {
      type: String
    },
    serverImageUrl: {
      type: String
    },
    labelText: {
      type: String
    },
    readOnly: {
      type: Boolean
    }
  },
  data() {
    return {
      cameraModal: false,
      imageModal: false,
      image: this.value,
      imageUrl: null,
      pictureErrors: [],
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false
    };
  },
  methods: {
    emit() {
      this.$emit("input", this.image);
    },
    showImage() {
      var url = this.imageUrl ? this.imageUrl : this.serverImageUrl;
      window.open(url, "_blank");
    },
    closeCameraModal() {
      this.cameraModal = false;
      this.stopCameraStream();
      this.isCameraOpen = false;
    },
    chooseFile() {
      this.$refs.fileUpload.click();
    },
    async setImage() {
      const file = this.$refs.fileUpload.files[0];
      const blobUrl = URL.createObjectURL(file);
      this.imageUrl = blobUrl;
      const blob = await resizeImage(blobUrl, 1920, 1920);
      this.image = await fileToBase64(blob);
      this.emit();
    },
    resetImage: function() {
      this.image = null;
      this.isPhotoTaken = false;
      this.emit();
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.cameraModal = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: true
      });
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.$refs.camera.srcObject = stream;
        })
        .catch(() => {
          alert(
            "The browser didn't support this feature or there is some errors."
          );
        });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();
      tracks.forEach(track => {
        track.stop();
      });
    },
    getCanvasToBlob(canvas) {
      return new Promise(function(resolve) {
        canvas.toBlob(
          blob => {
            resolve(blob);
          },
          "image/jpeg",
          1
        );
      });
    },
    getBlobToFile(theBlob, fileName) {
      return new File([theBlob], fileName, {
        lastModified: new Date().getTime(),
        type: "image/jpeg"
      });
    },
    async takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;
        setTimeout(() => {
          this.isShotPhoto = false;
        }, 50);
      }
      const canvas = document.getElementById("photoTaken");
      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
      var blob = await this.getCanvasToBlob(canvas);
      var file = this.getBlobToFile(blob, "picture");
      const url = URL.createObjectURL(file);
      const resizedBlob = await resizeImage(url, 1920, 1920);
      this.image = await fileToBase64(resizedBlob);
      this.imageUrl = url;
      this.closeCameraModal();
      this.emit();
    }
  }
};
</script>

<style scoped>
.token-container {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-flow: column;
  border: 2px dotted darkgrey;
  border-radius: 5px;
  width: 100%;
  height: 120px;
  justify-content: center;
  text-align: center;
}
img {
  width: 249px;
  height: fit-content;
}
.picture-container * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.picture-container-readonly * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hover-icons {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-flow: row;
  font-size: 20px;
  z-index: 10;
  border-radius: 5px;
}

.icons-container {
  display: none;
}

.picture-container:hover .icons-container,
.picture-container-readonly:hover .icons-container {
  display: flex;
}

.picture-container-readonly:hover > div,
.picture-container:hover > div {
  background-color: rgba(207, 227, 245, 0.9);
}
</style>
